import { render, staticRenderFns } from "./RenWei.vue?vue&type=template&id=3d666872&scoped=true&"
import script from "./RenWei.vue?vue&type=script&lang=js&"
export * from "./RenWei.vue?vue&type=script&lang=js&"
import style0 from "./RenWei.vue?vue&type=style&index=0&id=3d666872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d666872",
  null
  
)

export default component.exports